// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"318":"5c24b4ed","561":"38d2ec88","614":"fdf071cc","625":"d20b9000","984":"2fdb9e6a"}[chunkId] + ".chunk.js";
};